<template>
  <div class="motor-container">
    <ul class="list-group d-flex flex-wrap">
      <li
        class="list-group-item d-flex align-items-center motor-item"
        v-for="motor in motores"
        :key="motor.id"
        @click="openModal(motor)"
      >
        <div class="motor-details d-flex align-items-center">
          <img
            v-if="motor.status === 1"
            src="/images/icons/ventilador2.png"
            alt="Motor Ligado"
            class="motor-icon"
          />
          <div class="motor-text">
            <h5 class="motor-title">{{ motor.descricao }}</h5>
            <span
              :class="[
                'badge',
                motor.status === 1 ? 'bg-success' : 'bg-danger',
              ]"
            >
              {{ motor.status === 1 ? "LIGADO" : "DESLIGADO" }}
            </span>
          </div>
        </div>
        <small class="text-muted ms-auto">{{ aeracaoData }}</small>
      </li>
    </ul>
    <div v-if="showModal && modoOperacao == 0" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <h5>Acionamento Manual:</h5>
        <p><strong>Descrição:</strong> {{ selectedMotor.descricao }}</p>
        <p>
            {{ aeracao }}
          <strong>Status:</strong>
          <span :class="selectedMotor.status === 1 ? 'text-success' : 'text-danger'"> &nbsp;
            {{ selectedMotor.status === 1 ? "Ligado" : "Desligado" }}
          </span>
        </p>
        <div>
            <button class="btn btn-info" @click="sendCommandManual(1)" :disabled="disable">Acionar</button>
            <button class="btn btn-sucess" @click="sendCommandManual(0)" :disabled="disable">Desligar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";

export default {
    setup () {
        const route = useRoute();
        const toast = useToast();

        return {
            siloId: route.params.silo,
            toast
        };
    },
    props: {
        motores: {
            type: Array,
            default: () => [],
        },
        aeracaoData: {
            type: [String, Date],
            default: null,
        },
        modoOperacao: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            showModal: false,
            selectedMotor: {},
            disable: false
        };
    },
    methods: {
        openModal(motor) {
            this.selectedMotor = motor;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedMotor = {};
        },
        async sendCommandManual(command) {
            this.disable = true
            const datas = {
                descricao: this.selectedMotor.descricao,
                modulo: this.selectedMotor.modulo,
                saida: this.selectedMotor.saida,
                comando: command,
            };
            try {
                let response = await this.$store.dispatch('silo/SendMotorManualCommand', {"data": datas, "siloId": this.siloId})
                this.toast.info("Comando do motor enviado ao Painel TermoWeb, aguardando confirmação...", { timeout: 3900 });
                let messageId = response.message.message_id;
                setTimeout(async () => {
                    let msg = await this.$store.dispatch("message/fetchMessage", messageId);
                    if (msg.status !== 'processed') {
                        this.toast.error("O painel não conseguiu receber o comando.");
                    } else {
                        this.toast.success("Comando enviado ao motor.");
                    }
                }, 4000);
            } catch (error) {
                this.toast.error(error.response.data.message || "Erro ao enviar comando manual");
            }
            this.disable = false

        }
    },
};
</script>

<style scoped>
    .motor-container {
        margin-top: 1rem;
    }

    .list-group {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem; 
        flex-direction: row;
    }

    .list-group-item {
        display: flex;
        align-items: center;
        flex: 0 1 calc(30% - 1rem);
        max-width: 300px;
        border: 1px solid #dee2e6;
        border-radius: 0.5rem;
        padding: 1rem;
        transition: background-color 0.2s, box-shadow 0.2s;
        box-sizing: border-box;
        overflow: hidden;
    }

    .list-group-item:hover {
        background-color: #f8f9fa;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .motor-details {
        display: flex;
        align-items: center;
        flex-grow: 1;
        margin-right: 1rem;
    }

    .motor-text {
        display: flex;
        flex-direction: column;
    }

    .motor-title {
        font-size: 1rem;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .badge {
        font-size: 0.9rem;
        padding: 0.5rem;
        margin-left: 0.5rem;
    }

    .bg-success {
        background-color: #28a745;
    }

    .bg-danger {
        background-color: #dc3545;
    }

    .text-muted {
        font-size: 0.9rem;
    }

    .motor-icon {
        width: 24px;
        height: 24px;
        margin-right: 0.5rem;
        animation: loading 2s linear infinite;
    }

    .motor-item {
        min-width: 300px;
    }

    @keyframes loading {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
    }

    @media (max-width: 768px) {
        .motor-item {
            min-width: 100%;
        }
    }
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal-content {
        background: white;
        padding: 1.5rem;
        border-radius: 8px;
        width: 90%;
        max-width: 400px;
        text-align: center;
    }
</style>
